import deepPurple from '@material-ui/core/colors/deepPurple'

export const darkTheme = {
	palette: {
		type: 'dark',
		primary: {
			main: deepPurple[500],
		},
		background: {
			paper: '#252b45',
		},
	},
}
